// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vy_a bhm_b bhm_we"};